module.exports = __webpack_public_path__ + "media/images/logo1-152f15ae4d8c287e0106247f4a38106a.png";